// src/hooks/useAuth.js
import { useEffect, useState } from "react";
import { auth } from "../firebase";

export function useAuth() {
    const [user, setUser] = useState(undefined);
    useEffect(() => {
        return auth.onAuthStateChanged(u => setUser(u));
    }, []);
    return user;
}
